import * as React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Textarea, Button } from '@siteground/styleguide';

import { sendInquiry, setChatStatus } from '../../app-communication/actions/from-client-frontend';
import { ChatLayout } from '../../components/chat-layout';
import { ChatLogo } from '../../components/chat-logo';
import { CHAT_STATE } from '../../constants';
import { getFormDataErrors, getOnLoginFailureErrors } from './utils';
import { getOptions } from '../../selectors/options';
import { CHAT_MAX_HEIGHT, isDeviceHeightBelow } from '../../utils/display';

const Inquiry = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { initial_question } = useSelector(getOptions);
  const [inquiry, setInquiry] = React.useState(initial_question);
  const [errors, setErrors] = React.useState({
    inquiry: null
  });
  return (
    <ChatLayout
      header={<ChatLogo />}
      content={
        <Grid gap="x-large">
          <Textarea
            autoFocus
            rows={isDeviceHeightBelow(CHAT_MAX_HEIGHT) ? '15' : '18'}
            label={intl.formatMessage({ id: 'translate.describe.inquiry' })}
            value={inquiry}
            state={errors.inquiry ? 'error' : undefined}
            validationMessage={errors.inquiry && intl.formatMessage({ id: errors.inquiry })}
            onChange={(event) => setInquiry(event.target.value)}
          />

          <div style={{ textAlign: 'center' }}>
            <Button
              color="primary"
              onClick={() => {
                const formErrors = getFormDataErrors({ inquiry });
                const hasErrors = Object.values(formErrors).filter(Boolean).length;

                if (hasErrors) {
                  return setErrors(formErrors);
                }

                dispatch(
                  sendInquiry({
                    inquiry,
                    onComplete: () => {},
                    onFailure: (response) => {
                      const responseErrors = getOnLoginFailureErrors({ response });
                      const hasErrors = Object.values(responseErrors).filter(Boolean).length;

                      if (hasErrors) {
                        return setErrors(responseErrors);
                      }

                      if (!response.data || !response.data.error) {
                        return;
                      }

                      if (response.data.error.busy) {
                        dispatch(setChatStatus(CHAT_STATE.NO_AVAILABLE_OPERATOR));
                      }

                      if (response.data.error.chatting) {
                        dispatch(setChatStatus(CHAT_STATE.CURRENTLY_CHATTING));
                      }
                    }
                  })
                );
              }}
            >
              {intl.formatMessage({ id: 'translate.login.submit.button' })}
            </Button>
          </div>
        </Grid>
      }
    />
  );
};

export default Inquiry;
